import { render, staticRenderFns } from "./zdyrbbaozhuang.vue?vue&type=template&id=12d65798&scoped=true&"
import script from "./zdyrbbaozhuang.vue?vue&type=script&lang=js&"
export * from "./zdyrbbaozhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d65798",
  null
  
)

export default component.exports